import { Inject, Injectable, Optional } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'common/dayjs';
import { DATEPICKER_DELIMITER_TOKEN, DEFAULT_DATEPICKER_DELIMITER } from '@certemy/ui-components';

@Injectable()
export class CustomDatePickerParserFormatter extends NgbDateParserFormatter {
  constructor(@Optional() @Inject(DATEPICKER_DELIMITER_TOKEN) private delimiter: string) {
    super();
    if (!delimiter) {
      this.delimiter = DEFAULT_DATEPICKER_DELIMITER;
    }
  }

  parse(value: string): NgbDateStruct | null {
    if (value) {
      // dayjs strict customParseFormat: "M" does not accept zero-padded months (unlike moment).
      // Accept both unpadded and padded forms so "06-05-2024" keeps working after migration.
      const date = dayjs(
        value,
        [`M${this.delimiter}D${this.delimiter}YYYY`, `MM${this.delimiter}DD${this.delimiter}YYYY`],
        true,
      );
      if (date.isValid()) {
        return {
          day: date.date(),
          month: date.month() + 1,
          year: date.year(),
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? dayjs(new Date(date.year, date.month - 1, date.day)).format(`MM${this.delimiter}DD${this.delimiter}YYYY`)
      : '';
  }
}
